import React from "react";
import Page from "../Components/Page";
import AutomationForm from "../features/automations/AutomationForm";
import useFetchData from "../hooks/useFetchData";
import { useParams } from "react-router-dom";
import { IDevice } from "../features/devices/types";
import { IControl } from "../features/controls/types";
import { IAutomation } from "../features/automations/types";
import { defaultLogAction } from "../features/automations/actions/types";
import { defaultNoneCondition } from "../features/automations/conditions/types";
import { defaultTimeTrigger } from "../features/automations/triggers/types";
import { useTranslation } from "react-i18next";

const newEmptyAutomation: IAutomation = {
  id: -1,
  name: "",
  is_enabled: true,
  trigger: defaultTimeTrigger,
  condition: defaultNoneCondition,
  action: defaultLogAction,
};

export const NewAutomationPage = () => {
  const { data: devices, isLoading: isDevicesLoading } =
    useFetchData<IDevice[]>("/devices");
  const { data: controls, isLoading: isControlsLoading } =
    useFetchData<IControl[]>("/controls");
  const { t } = useTranslation();
  return (
    <Page
      title={t("New Automation")}
      isLoading={isDevicesLoading || isControlsLoading}
    >
      {devices && controls && (
        <AutomationForm
          automation={newEmptyAutomation}
          devices={devices}
          controls={controls}
        />
      )}
    </Page>
  );
};

export const EditAutomationPage = () => {
  const params = useParams();
  const { data: devices, isLoading: isDevicesLoading } =
    useFetchData<IDevice[]>("/devices");
  const { data: controls, isLoading: isControlsLoading } =
    useFetchData<IControl[]>("/controls");
  const { data: automation, isLoading: isAutomationLoading } =
    useFetchData<IAutomation>(`/automations/${params.automationid}`);
  const { t } = useTranslation();
  return (
    <Page
      title={automation?.name || t("New Automation")}
      isLoading={isDevicesLoading || isControlsLoading || isAutomationLoading}
    >
      {devices && controls && automation && (
        <AutomationForm
          automation={automation}
          devices={devices}
          controls={controls}
        />
      )}
    </Page>
  );
};
